import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl } from 'react-bootstrap';
import { withRouter, Redirect } from 'react-router-dom';
import {browserHistory} from 'react-router'
import apiFetch from "../utils/apiFetch";

class AlbumAdd extends Component {

    constructor(props) {
        super(props);
        this.state = {
            album_link: null,
            photographer_contact: null,
            priority: "0",
            need_redirect_to_dashboard: false
        }
    }

    onChangeAlbumLink = (e) => {
        this.setState({album_link: event.target.value});
    }

    onChangePhotographerContact = (e) => {
        this.setState({photographer_contact: event.target.value});
    }

    onChangePriority = (e) => {
        this.setState({priority: event.target.value});
    }

    addAlbum = () => {
        apiFetch('albums.add', {
            url: this.state.album_link,
            contact: this.state.photographer_contact,
            priority: this.state.priority
        }).then((result) => {
            this.setState({need_redirect_to_dashboard: true})
        });
    }

    render() {
        return (
            <div className="col-md-5">
                {this.state.need_redirect_to_dashboard && <Redirect to="/dashboard" />}
                <Form>
                    <h3>Добавить альбом</h3>
                    <Form.Group>
                        <Form.Label>Ссылка на альбом</Form.Label>
                        <FormControl name="album_link" onChange={this.onChangeAlbumLink} placeholder="Ссылка на альбом"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Контакт фотографа</Form.Label>
                        <Form.Control as="textarea" name="photographer_contact" onChange={this.onChangePhotographerContact} placeholder="Контакт фотографа"/>
                    </Form.Group>
                    <Form.Group controlId="exampleForm.ControlSelect1">
                        <Form.Label>Приоритет</Form.Label>
                        <Form.Control as="select" onChange={this.onChangePriority}>
                            <option value="0">Низкий</option>
                            <option value="1">Средний</option>
                            <option value="2">Высокий</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <Button onClick={this.addAlbum}>Добавить</Button>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

export default withRouter(AlbumAdd);







// WEBPACK FOOTER //
// ./src/components/AlbumAdd.js